import client from '../../../api'
import type { RequestConfig, ResponseErrorConfig } from '../../../api'
import type {
  StatisticControllerGetGroupsRegisterStaticsQueryResponse,
  StatisticControllerGetGroupsRegisterStaticsQueryParams,
} from '../../ts/StatisticDTO/StatisticControllerGetGroupsRegisterStatics'

export function getStatisticControllerGetGroupsRegisterStaticsUrl() {
  return `/statistic/groups` as const
}

/**
 * @summary Получение статистики по количеству групп зарегистрированных за определенный период (по месяцам или годам)
 * {@link /statistic/groups}
 */
export async function statisticControllerGetGroupsRegisterStatics(
  params: StatisticControllerGetGroupsRegisterStaticsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<StatisticControllerGetGroupsRegisterStaticsQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getStatisticControllerGetGroupsRegisterStaticsUrl().toString(),
    params,
    ...requestConfig,
  })
  return res
}